import { EVENT_TYPE, MAIN_IDENTIFIER_TYPE } from 'src/features/eventLog/types';
import { DisplaySettingValue } from 'src/features/systems/utils/displaySettingTypes';
import { Translation } from 'src/types';

export enum SYSTEM_SETTINGS_CATEGORY {
    VISITORS = 'visitors',
    SYSTEM = 'system',
    GATEWAY_DISPLAY = 'gateway_display',
}

export enum SYSTEM_SETTINGS_CODE {
    SUPPORTED_IDENTIFIER_TYPES = 'supported_identifier_types',
    MAIN_IDENTIFIER_TYPE = 'main_identifier_type',
    ENABLED_MEMBERSHIP_CATEGORIES = 'enabled_membership_categories',
    ENABLED_EVENT_TYPES = 'enabled_event_types',
    AUTO_END_ACTIVE_STAY_AFTER_HOURS = 'auto_end_active_stay_after_hours',
}

export enum MEMBERSHIP_CATEGORY {
    VIP = 'vip',
    RESIDENT = 'resident',
    STAFF = 'staff',
    SERVICE = 'service',
    SUBSCRIPTION = 'subscription',
    RESERVATION = 'reservation',
}

type SystemSettingsValue =
    | EVENT_TYPE[]
    | MAIN_IDENTIFIER_TYPE[]
    | MAIN_IDENTIFIER_TYPE
    | MEMBERSHIP_CATEGORY[]
    | DisplaySettingValue;

export type SystemSettings = {
    id: string;
    created_at: string;
    modified_at: string;
    category: SYSTEM_SETTINGS_CATEGORY;
    code: SYSTEM_SETTINGS_CODE;
    value: SystemSettingsValue;
};

export enum SYSTEM_COMPONENT_TYPE {
    SOFTWARE = 'software',
    HARDWARE_DEVICE = 'hardware_device',
}

export enum SYSTEM_COMPONENT {
    LPR_CAMERA = 'lpr_camera',
    ACCESS_KEY_READER_COMMUNICATOR = 'access_key_reader_communicator',
    GATEWAY_COMMUNICATOR = 'gateway_communicator',
    SENSOR_READER_COMMUNICATOR = 'sensor_reader_communicator',
    CASH_API = 'cash_api',
    CARD_API = 'card_api',
    GATEWAY_DISPLAY = 'gateway_display',
    FISCAL_DEVICE = 'fiscal_device',
    BACKEND_HTTP_SERVICE = 'backend_http_service',
    BACKEND_WORKER_SERVICE = 'backend_worker_service',
    BACKEND_INFRA_SERVICE = 'backend_infra_service',
    TICKET_PRINTER = 'ticket_printer',
}

export enum FISCAL_DEVICE_TYPE {
    BG_PAPER = 'bg_paper',
    BG_FUVAS = 'bg_fuvas',
}

export enum COMMUNICATOR_TYPE {
    SP_MQTT = 'SP_MQTT',
}

export enum CAMERA_TYPE {
    SP_LPR = 'sp_lpr',
    ICE_LPR = 'ice_lpr',
    IPNC_LPR = 'ipnc_lpr',
    ISAPI1_LPR = 'isapi1_lpr',
    EINAR_LPR = 'einar_lpr',
}

export enum SYSTEM_COMPONENT_STATUS {
    OPERATIONAL = 'operational',
    WARNING = 'warning',
    ERROR = 'error',
    NO_CONNECTION = 'no_connection',
}

export enum GATEWAY_DISPLAY_MODEL {
    SP = 'SP',
    HUIDU = 'HUIDU',
    NED200 = 'NED200',
    NED200C = 'NED200c',
}

export enum ORIENTATION {
    PORTRAIT = 'portrait',
    LANDSCAPE = 'landscape',
}

export enum LISTEN_STATE {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
}

export enum POSITION {
    FRONT = 'front',
    CENTER = 'center',
    BACK = 'back',
}

export enum IDLE_STATE {
    DATE = 'date',
    SPACES = 'spaces',
    LPR = 'lpr',
    TICKET = 'ticket',
    CARD = 'card',
}

export enum ALIGN {
    CENTER = 'center',
    LEFT = 'left',
    RIGHT = 'right',
}

export enum TICKET_PRINTER_ROW_TYPE {
    TEXT = 'text',
    BARCODE = 'barcode',
    LOGO = 'logo',
    // QR = 'qr',
}

export type TicketPrinterPayload = {
    align: ALIGN;
    type: TICKET_PRINTER_ROW_TYPE;
    text?: string;
};

export type DataJson = {
    type?: CAMERA_TYPE | COMMUNICATOR_TYPE | FISCAL_DEVICE_TYPE;
    make?: string;
    model?: string | GATEWAY_DISPLAY_MODEL;
    serial_number?: string;
    rtsp_stream_url?: string;
    channel?: number;
    topic_code?: string;
    persistent_channel?: number;
    open_duration?: number;
    display_server_ip?: string;
    display_server_api_key?: string;
    listen_state?: LISTEN_STATE;
    status_channel?: number;
    status_listen_state?: LISTEN_STATE;
    idle_state?: IDLE_STATE;
    orientation?: ORIENTATION;
    sdk_key?: string;
    sdk_secret?: string;
    api_key?: string;
    api_url?: string;
    device_id?: string;
    display_width?: number;
    display_height?: number;
    display_title_font_size?: number;
    display_subtitle_font_size?: number;
    display_title_only_font_size?: number;
    display_model?: GATEWAY_DISPLAY_MODEL;
    position?: POSITION;
    payload?: TicketPrinterPayload[];
};

export type SystemComponent = {
    id: string;
    created_at: string;
    modifier_at: string;
    component_type: SYSTEM_COMPONENT_TYPE;
    component: SYSTEM_COMPONENT;
    name: string;
    status: SYSTEM_COMPONENT_STATUS;
    data?: DataJson;
    code: string;
    zone?: {
        id: string;
        translations: Translation[];
    };
    gateway?: {
        id: string;
        translations: Translation[];
    };
    pay_station?: {
        id: string;
        name: string;
    };
    logo_url?: string;
};
